var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vr360-app"},[_c('header-list'),_c('main',{ref:"scrollContainer",staticClass:"vr360-app-main vr360-wrap__inner"},[_c('router-view',{key:_vm.$route.path})],1),_c('footer-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }